import { AppInstance } from "../../api/instance";

export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const DELETE_FROM_WISHLIST = "DELETE_FROM_WISHLIST";
export const DELETE_ALL_FROM_WISHLIST = "DELETE_ALL_FROM_WISHLIST";
export const GET_WISHLIST_DATA = "GET_WISHLIST_DATA"

// add to wishlist
export const addToWishlist = (item, addToast) => {
  return dispatch => {
    // Make API call first
    AppInstance({
      method: 'post',
      url: '/wishlist',
      data: {
        variant_id: item.id,
      }
    }).then((res) => {
      if (res.status === 200) {
        // Show success toast only when API call succeeds
        if (addToast) {
          addToast("Added To Wishlist", { 
            appearance: "success", 
            autoDismiss: true 
          });
        }
        
        // Dispatch to update state only after API success
        dispatch({ type: ADD_TO_WISHLIST, payload: { ...item } });
      } else {
        // Show error toast if API call fails
        if (addToast) {
          addToast("Failed to add item to wishlist", { 
            appearance: "error", 
            autoDismiss: true 
          });
        }
      }
    }).catch((error) => {
      console.log(error, "wishlist add fail");
      // Show error toast if API call fails
      if (addToast) {
        addToast("Failed to add item to wishlist", { 
          appearance: "error", 
          autoDismiss: true 
        });
      }
    });
  };
};
export const getWishlist = (userInfo) => {
  return async (dispatch) => {
    if (!userInfo) {
      return
    }
    try {
      const { data } = await AppInstance.get('/wishlist', {
        headers: {
          Authorization: `Bearer ${userInfo.token}`
        }
      });
      const wishlistItems = data.data.map((item) => ({
        ...item.variant,
        quantity: 1,
      }));

      dispatch({
        type: GET_WISHLIST_DATA,
        payload: wishlistItems
      });
    } catch (error) {
      console.log(error);
    }
  };
}
// delete from wishlist
export const deleteFromWishlist = (item, addToast) => {
  return dispatch => {
    // Make API call first
    AppInstance({
      method: 'delete',
      url: `/wishlist?variant_id=${item.id}`,
    }).then((res) => {
      if (res.status === 200) {
        // API call successful, remove from state
        dispatch({ type: DELETE_FROM_WISHLIST, payload: item });
        if (addToast) {
          addToast("Removed From Wishlist", {
            appearance: "info",
            autoDismiss: true
          });
        }
      } else {
        // Show error if API call fails
        if (addToast) {
          addToast("Failed to remove item from wishlist", {
            appearance: "error",
            autoDismiss: true
          });
        }
      }
    }).catch((error) => {
      console.log(error, "wishlist delete fail");
      if (addToast) {
        addToast("Failed to remove item from wishlist", {
          appearance: "error",
          autoDismiss: true
        });
      }
    });
  };
};

//delete all from wishlist
export const deleteAllFromWishlist = addToast => {
  return dispatch => {
    // Make API call first
    AppInstance({
      method: 'delete',
      url: '/wishlist/clear',
    }).then((res) => {
      if (res.status === 200) {
        // API call successful, clear all items
        dispatch({ type: DELETE_ALL_FROM_WISHLIST });
        if (addToast) {
          addToast("Removed All From Wishlist", {
            appearance: "info",
            autoDismiss: true
          });
        }
      } else {
        // Show error if API call fails
        if (addToast) {
          addToast("Failed to clear wishlist", {
            appearance: "error",
            autoDismiss: true
          });
        }
      }
    }).catch((error) => {
      console.log(error, "wishlist clear fail");
      if (addToast) {
        addToast("Failed to clear wishlist", {
          appearance: "error",
          autoDismiss: true
        });
      }
    });
  };
};
